import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import authenticate from '../../utils/Authenticate';
import UserContext from '../../contexts/UserContext';

const ZoneSupplierList = () => {
  const { state } = useLocation();
  const [suppliers, setSuppliers] = useState([]);
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [currentItem, setCurrentItem] = useState(state?.item || null);

  const getSuppliers = async () => {
    if (!state?.item?._id) return;
    await axios.get(`${process.env.REACT_APP_API_URI}/api/supplier/getZoneSupplierItems?item=${state.item._id}`, { withCredentials: true })
      .then((response) => {
        if (response.data.success) {
          setSuppliers(response.data.data);
        }
      })
      .catch(error => console.error("Error fetching suppliers:", error));
  };

  const assignSupplier = (supplier) => {
    const updatedItems = state.items.map((item) => {
      if (item._id === state.item._id) {
        return { ...item, supplier, supplierSelected: true };
      }
      return item;
    });

    navigate('/zc/checklist', { state: { itemsReceived: updatedItems } });
  };

  useEffect(() => {
    async function startup() {
      if (!user) {
        await authenticate(setUser, navigate);
      }
      if (user) {
        setCurrentItem(state.item);
        getSuppliers();
      }
    }
    startup();
  }, [user, state.item, setUser, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center bg-gray-100">
      <div className="bg-fmb-light p-4 w-full shadow-md flex items-center mb-4">
        <button className="mr-4" onClick={() => navigate('/zc/checklist', { state: { itemsReceived: state.items } })}>
          <span className="text-xl">←</span>
        </button>
        <div className="flex-1 flex flex-col items-center text-center">
          <h4 className="text-lg font-semibold">
            {currentItem?.name} - {currentItem?.quantity} {currentItem?.unit}
          </h4>
          <h4 className="text-sm text-black opacity-60">
            Category: {currentItem?.category}
          </h4>
        </div>
      </div>
      <ul className="w-full max-w-2xl space-y-4">
        {suppliers.map((supplier, index) => (
          <li key={index} className="bg-white p-4 rounded shadow-md flex justify-between items-center mx-2">
            <div className="flex flex-col">
              <span className="font-semibold">{supplier.name}</span>
              <span className="text-sm text-gray-600">{supplier.company}</span>
              <span className="text-sm text-gray-500 mt-1">{supplier.address}</span>
            </div>
            <button 
              onClick={() => assignSupplier(supplier)} 
              className={`w-6 h-6 rounded-full ${currentItem?.supplier?._id === supplier._id ? 'bg-green-500' : 'bg-gray-300'}`}
            >
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ZoneSupplierList;